import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);

    }

    init() {

        this.swiper = new Swiper(this.$('slider')[0], {
            loop: true,
            speed: 600,
            direction: 'vertical',
            autoplay: {
                delay: 2000
            }
        });
    }

    destroy() {
        this.swiper?.destroy?.()
    }

}
